import { render, staticRenderFns } from "./DailyExpense.vue?vue&type=template&id=5b8da06c&"
import script from "./DailyExpense.vue?vue&type=script&lang=js&"
export * from "./DailyExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports